export default {
  kits: '/dashboard/kits',
  kitsTemplate: '/dashboard/kits/template/:kitId',
};
